import { ContextMenu } from '@/components/shared/ContextMenu';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useRouteChange } from '@/utils/useRouteChange';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { rem } from 'polished';
import { useCallback, useEffect } from 'react';
import { UserMenu } from '../../Menu/UserMenu';
import { MenuScreen, useMenu } from '../../useHeaderSettings/useMenu';
import { UserSessionButton } from './UserSessionButton';

export const UserButton = () => {
  const { user, authenticate, isAuthenticated } = useAuthentication();
  const { setMenu } = useMenu(state => ({ setMenu: state.setMenu }));

  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false }, 'md');

  /** On desktop we want to open a popover, but on mobile we want to open a hamburger menu. */
  const handleOpening = useCallback(() => {
    if (!isAuthenticated) return authenticate();
    if (!isMobile) return onOpen();
    return setMenu(MenuScreen.User);
  }, [isAuthenticated, isMobile, setMenu, onOpen, authenticate]);

  /** Close the popover when the user is not authenticated anymore, usually after a logout. */
  useEffect(() => {
    if (!isAuthenticated) onClose();
  }, [isAuthenticated, onClose]);

  /** Close the popover every time a route changes. */
  useRouteChange('routeChangeStart', onClose);

  return (
    <Popover
      isOpen={isOpen}
      onOpen={handleOpening}
      onClose={onClose}
      closeOnBlur
      closeOnEsc
      placement="bottom-end"
    >
      <PopoverTrigger>
        <UserSessionButton isOpen={isOpen} />
      </PopoverTrigger>

      {!!user && !isMobile && (
        <PopoverContent width={rem(314)} border="none">
          <ContextMenu zIndex="header.inFront">
            <UserMenu activeLinkColor="white" />
          </ContextMenu>
        </PopoverContent>
      )}
    </Popover>
  );
};
